import slsReporter from './src/index.js'

import wpkglobalerrorPlugin from './src/plugins/globalerror';
import wpkperformancePlugin from './src/plugins/performance';
import wpkblankPlugin from './src/plugins/blank';
import wpkflowPlugin from './src/plugins/flow'
import wpkinterfacePlugin from './src/plugins/interface'
import wpkngPlugin from './src/plugins/ng'
import wpkucparamPlugin from './src/plugins/ucparam'
import wpkvuePlugin from './src/plugins/vue'

export default slsReporter

export {
  wpkglobalerrorPlugin,
  wpkperformancePlugin,
  wpkblankPlugin,
  wpkflowPlugin,
  wpkinterfacePlugin,
  wpkngPlugin,
  wpkucparamPlugin,
  wpkvuePlugin
}
